import * as lscache from "lscache";

import {IRange, MAX_VALUE_INPUT_LIMITER} from "@pg-design/inputs-module";
import {IOption} from "@pg-design/select-module";
import {uniqBy} from "@pg-mono/nodash";

import {HOME_MATCH_PENDING_PREFERENCES_KEY, HOME_MATCH_PREFERENCES_SESSION_KEY, SENT_PREFERENCES_WITH_APPLICATION} from "../../../app/constants/storage_keys";
import {IClientUpdatePayload} from "../../../for_you/api/for_you_client";

const budgetRoundingStep = 5000;

export type HomeMatchPreferences = {
    rooms?: IRange<string | number>;
    budget?: number | null;
    price?: IRange<number>;
    regions?: IOption<number>[];
    searchRegions?: IOption<number>[];
} | null;

export const useHomeMatchPreferencesStorage = () => {
    const getPreferences = (): HomeMatchPreferences | null => {
        return lscache.get(HOME_MATCH_PREFERENCES_SESSION_KEY);
    };

    /**
     * HomeMatch preferences storage should be built over time, based on search history and applications.
     * Cumulatively store every search or application parameters.
     */
    const putPreferences = (preferences: HomeMatchPreferences) => {
        const storedPreferences = getPreferences();

        const newBudget = preferences?.budget || preferences?.price?.upper;
        const adjustedBudget = newBudget && adjustBudget(newBudget);

        const isStoredRoomsValid =
            (storedPreferences?.rooms?.lower !== "" && storedPreferences?.rooms?.upper !== "") ||
            (storedPreferences?.rooms?.lower === "" && storedPreferences?.rooms?.upper !== "") ||
            (storedPreferences?.rooms?.lower !== "" && storedPreferences?.rooms?.upper === "");
        const isNewRoomsValid =
            (preferences?.rooms?.lower !== "" && preferences?.rooms?.upper !== "") ||
            (preferences?.rooms?.lower === "" && preferences?.rooms?.upper !== "") ||
            (preferences?.rooms?.lower !== "" && preferences?.rooms?.upper === "");

        const newPreferences = {
            rooms:
                isStoredRoomsValid && isNewRoomsValid && storedPreferences?.rooms
                    ? extendRange(storedPreferences.rooms, preferences?.rooms)
                    : isNewRoomsValid
                      ? preferences?.rooms
                      : storedPreferences?.rooms,
            budget: storedPreferences?.budget ? extendBudget(storedPreferences?.budget, adjustedBudget) : adjustedBudget,
            regions: uniqBy([...(storedPreferences?.regions || []), ...(preferences?.regions || [])], (reg) => reg.value), // region.id is stored as value
            searchRegions: uniqBy([...(storedPreferences?.searchRegions || []), ...(preferences?.searchRegions || [])], (reg) => reg.value)
        };

        lscache.set(HOME_MATCH_PREFERENCES_SESSION_KEY, newPreferences);
    };

    /**
     * set preferences in session storage on preferences form submission only
     */
    const setPreferences = (preferences: HomeMatchPreferences) => {
        lscache.set(HOME_MATCH_PREFERENCES_SESSION_KEY, JSON.stringify(preferences));
    };

    const preferencesSentStorage: {sent: boolean; email: string} | null = lscache.get(SENT_PREFERENCES_WITH_APPLICATION);

    const setPreferencesSent = (preferencesWereSent: boolean, preferences: HomeMatchPreferences, email?: string) => {
        if (preferences) {
            const validBudget = preferences?.budget && preferences.budget >= MAX_VALUE_INPUT_LIMITER ? "" : preferences.budget;

            lscache.set(HOME_MATCH_PREFERENCES_SESSION_KEY, {...preferences, budget: validBudget});
        }

        // store a temporary flag to avoid showing the preferences modal too frequently
        lscache.set(SENT_PREFERENCES_WITH_APPLICATION, {sent: preferencesWereSent, email});
    };

    /**
     * Get pending preferences saved by unauthenticated users (waiting for API sync)
     */
    const getPendingPreferences = (): HomeMatchPreferences | null => {
        return lscache.get(HOME_MATCH_PENDING_PREFERENCES_KEY);
    };

    /**
     * Save pending preferences for unauthenticated users (will be synced on next login)
     * Overwrites existing preferences (not cumulative like putPreferences)
     */
    const putPendingPreferences = (preferences: IClientUpdatePayload) => {
        lscache.set(HOME_MATCH_PENDING_PREFERENCES_KEY, preferences);
    };

    /**
     * Clear pending preferences
     */
    const clearPendingPreferences = () => {
        lscache.remove(HOME_MATCH_PENDING_PREFERENCES_KEY);
    };

    return {
        preferencesSentStorage,
        setPreferencesSent,
        setPreferences,
        getPreferences,
        putPreferences,
        getPendingPreferences,
        putPendingPreferences,
        clearPendingPreferences
    };
};

const getLowestValue = (oldValue: string | number | undefined, newValue: string | number | undefined) => {
    if (oldValue === "" || newValue === "") {
        return "";
    }

    if (!oldValue || !newValue) {
        return oldValue || newValue;
    }
    return Math.min(Number(oldValue), Number(newValue));
};

const getHighestValue = (oldValue: string | number | undefined, newValue: string | number | undefined) => {
    if (oldValue === "" || newValue === "") {
        return "";
    }
    if (!oldValue || !newValue) {
        return oldValue || newValue;
    }
    return Math.max(Number(oldValue), Number(newValue));
};

const extendRange = (oldRange: IRange<string | number>, expandRange?: IRange<string | number> | undefined): IRange<string | number> => {
    const lower = getLowestValue(oldRange.lower, expandRange?.lower) || "";
    const upper = getHighestValue(oldRange.upper, expandRange?.upper) || "";

    return {
        lower,
        upper
    };
};

/**
 * returns largest between old and new budget value
 */
const extendBudget = (oldValue: number | null, newValue: number | null | undefined) => {
    if (!oldValue || !newValue) {
        return oldValue || newValue;
    }

    return Math.max(oldValue, newValue);
};

/**
 * Round budget value up to 5k increments
 */
const adjustBudget = (value: number) => {
    return Math.ceil(value / budgetRoundingStep) * budgetRoundingStep;
};
import * as lscache from "lscache";

import {IRange, MAX_VALUE_INPUT_LIMITER} from "@pg-design/inputs-module";
import {IOption} from "@pg-design/select-module";
import {uniqBy} from "@pg-mono/nodash";

import {HOME_MATCH_PENDING_PREFERENCES_KEY, HOME_MATCH_PREFERENCES_SESSION_KEY, SENT_PREFERENCES_WITH_APPLICATION} from "../../../app/constants/storage_keys";
import {IClientUpdatePayload} from "../../../for_you/api/for_you_client";

const budgetRoundingStep = 5000;

export type HomeMatchPreferences = {
    rooms?: IRange<string | number>;
    budget?: number | null;
    price?: IRange<number>;
    regions?: IOption<number>[];
    searchRegions?: IOption<number>[];
} | null;

export const useHomeMatchPreferencesStorage = () => {
    const getPreferences = (): HomeMatchPreferences | null => {
        return lscache.get(HOME_MATCH_PREFERENCES_SESSION_KEY);
    };

    /**
     * HomeMatch preferences storage should be built over time, based on search history and applications.
     * Cumulatively store every search or application parameters.
     */
    const putPreferences = (preferences: HomeMatchPreferences) => {
        const storedPreferences = getPreferences();

        const newBudget = preferences?.budget || preferences?.price?.upper;
        const adjustedBudget = newBudget && adjustBudget(newBudget);

        const isStoredRoomsValid =
            (storedPreferences?.rooms?.lower !== "" && storedPreferences?.rooms?.upper !== "") ||
            (storedPreferences?.rooms?.lower === "" && storedPreferences?.rooms?.upper !== "") ||
            (storedPreferences?.rooms?.lower !== "" && storedPreferences?.rooms?.upper === "");
        const isNewRoomsValid =
            (preferences?.rooms?.lower !== "" && preferences?.rooms?.upper !== "") ||
            (preferences?.rooms?.lower === "" && preferences?.rooms?.upper !== "") ||
            (preferences?.rooms?.lower !== "" && preferences?.rooms?.upper === "");

        const newPreferences = {
            rooms:
                isStoredRoomsValid && isNewRoomsValid && storedPreferences?.rooms
                    ? extendRange(storedPreferences.rooms, preferences?.rooms)
                    : isNewRoomsValid
                      ? preferences?.rooms
                      : storedPreferences?.rooms,
            budget: storedPreferences?.budget ? extendBudget(storedPreferences?.budget, adjustedBudget) : adjustedBudget,
            regions: uniqBy([...(storedPreferences?.regions || []), ...(preferences?.regions || [])], (reg) => reg.value), // region.id is stored as value
            searchRegions: uniqBy([...(storedPreferences?.searchRegions || []), ...(preferences?.searchRegions || [])], (reg) => reg.value)
        };

        lscache.set(HOME_MATCH_PREFERENCES_SESSION_KEY, newPreferences);
    };

    /**
     * set preferences in session storage on preferences form submission only
     */
    const setPreferences = (preferences: HomeMatchPreferences) => {
        lscache.set(HOME_MATCH_PREFERENCES_SESSION_KEY, JSON.stringify(preferences));
    };

    const preferencesSentStorage: {sent: boolean; email: string} | null = lscache.get(SENT_PREFERENCES_WITH_APPLICATION);

    const setPreferencesSent = (preferencesWereSent: boolean, preferences: HomeMatchPreferences, email?: string) => {
        if (preferences) {
            const validBudget = preferences?.budget && preferences.budget >= MAX_VALUE_INPUT_LIMITER ? "" : preferences.budget;

            lscache.set(HOME_MATCH_PREFERENCES_SESSION_KEY, {...preferences, budget: validBudget});
        }

        // store a temporary flag to avoid showing the preferences modal too frequently
        lscache.set(SENT_PREFERENCES_WITH_APPLICATION, {sent: preferencesWereSent, email});
    };

    /**
     * Get pending preferences saved by unauthenticated users (waiting for API sync)
     */
    const getPendingPreferences = (): HomeMatchPreferences | null => {
        return lscache.get(HOME_MATCH_PENDING_PREFERENCES_KEY);
    };

    /**
     * Save pending preferences for unauthenticated users (will be synced on next login)
     * Overwrites existing preferences (not cumulative like putPreferences)
     */
    const putPendingPreferences = (preferences: IClientUpdatePayload) => {
        lscache.set(HOME_MATCH_PENDING_PREFERENCES_KEY, preferences);
    };

    /**
     * Clear pending preferences
     */
    const clearPendingPreferences = () => {
        lscache.remove(HOME_MATCH_PENDING_PREFERENCES_KEY);
    };

    return {
        preferencesSentStorage,
        setPreferencesSent,
        setPreferences,
        getPreferences,
        putPreferences,
        getPendingPreferences,
        putPendingPreferences,
        clearPendingPreferences
    };
};

const getLowestValue = (oldValue: string | number | undefined, newValue: string | number | undefined) => {
    if (oldValue === "" || newValue === "") {
        return "";
    }

    if (!oldValue || !newValue) {
        return oldValue || newValue;
    }
    return Math.min(Number(oldValue), Number(newValue));
};

const getHighestValue = (oldValue: string | number | undefined, newValue: string | number | undefined) => {
    if (oldValue === "" || newValue === "") {
        return "";
    }
    if (!oldValue || !newValue) {
        return oldValue || newValue;
    }
    return Math.max(Number(oldValue), Number(newValue));
};

const extendRange = (oldRange: IRange<string | number>, expandRange?: IRange<string | number> | undefined): IRange<string | number> => {
    const lower = getLowestValue(oldRange.lower, expandRange?.lower) || "";
    const upper = getHighestValue(oldRange.upper, expandRange?.upper) || "";

    return {
        lower,
        upper
    };
};

/**
 * returns largest between old and new budget value
 */
const extendBudget = (oldValue: number | null, newValue: number | null | undefined) => {
    if (!oldValue || !newValue) {
        return oldValue || newValue;
    }

    return Math.max(oldValue, newValue);
};

/**
 * Round budget value up to 5k increments
 */
const adjustBudget = (value: number) => {
    return Math.ceil(value / budgetRoundingStep) * budgetRoundingStep;
};
